import React, { useState, useEffect } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import styles from "./EditPrompts.css";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import Modal from "react-bootstrap/Modal";

export const EditPrompts = () => {
  const [prompts, setPrompts] = useState([]);
  const [partners, setPartners] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleCloseDataModel = () => setShowConfirmation(false);
  const [parterIcon, setPartnerIcon] = useState("");

  const [isPending, setIsPending] = useState(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );

  const [selectedReport, setSelectedReportDashboard] = useState();
  var selected_index_prop = queryParameters.get("selected_index");
  if (selected_index_prop == undefined) {
    selected_index_prop = 0;
  }

  function confirmedRevert() {
    setIsPending(true);
    setShowConfirmation(false);
    try {
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/revert_prompts",
          {
            partner_id: selectedPartner.partner_id,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          const selected_id = selectedPartner.partner_id;
          const filtered_prompts = response.data.filter(
            (val) => val.partner_id == selected_id
          );

          var maxValue = 0;
          for (const obj of filtered_prompts) {
            if (obj["version"] > maxValue) {
              maxValue = obj["version"];
            }
          }

          const result = [];
          for (const obj of filtered_prompts) {
            if (obj["version"] === maxValue) {
              result.push(obj);
            }
          }
          setIsPending(false);

          window.location.href =
            "/editPrompts?selected_index=" + selected_index;
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
  }

  function onClickBackToCopilot() {
    window.location.href = "/?selected_index=" + selected_index;
  }

  function onRevertPrompts() {
    setShowConfirmation(true);
  }

  const [selected_index, setSelectedIndex] = useState(selected_index_prop);
  const [selectedPartner, setSelectedPartner] = useState(
    partners[selected_index]
  );
  function handleTextChange(event) {}
  useEffect(() => {
    if (selected_index == undefined) {
      setSelectedIndex(0);
    }
  }, [selected_index]);
  function changePartner(evt) {
    setSelectedPartner(partners[evt]);
  }

  function changeHandle(value) {
    this.refs.fixedTextArea.value = value;
  }

  const onSubmit = (event) => {
    setIsPending(true);
    event.preventDefault();
    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData);
    console.log(data);

    let version = data.version;
    let triage = event.target.elements.TRIAGE.value;
    let monitor = event.target.elements.MONITOR.value;
    let general = event.target.elements.GENERAL.value;
    let schema = event.target.elements.SCHEMA.value;
    let sql = event.target.elements.SQL.value;
    let analysis = event.target.elements.ANALYSIS.value;
    let chart = event.target.elements.CHART.value;
    let validate = event.target.elements.VALIDATE.value;

    function onValInputChange(e) {
      this.setState({ [this.state.key]: e.target.value });
    }

    try {
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/updatePrompts",
          {
            partner_id: selectedPartner.partner_id,
            triage: triage,
            monitor: monitor,
            general: general,
            schema: schema,
            sql: sql,
            analysis: analysis,
            chart: chart,
            validate: validate,
            version: version,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          const selected_id = selectedPartner.partner_id;
          const filtered_prompts = response.data.filter(
            (val) => val.partner_id == selected_id
          );

          var maxValue = 0;
          for (const obj of filtered_prompts) {
            if (obj["version"] > maxValue) {
              maxValue = obj["version"];
            }
          }

          const result = [];
          for (const obj of filtered_prompts) {
            if (obj["version"] === maxValue) {
              result.push(obj);
            }
          }
          setIsPending(false);
          //   result.sort((a, b) => a.prompt_type.localeCompare(b.prompt_type));

          setPrompts(result);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
  };
  useEffect(() => {
    axios

      .post(
        process.env.REACT_APP_API_DOMAIN + "/get_partners",
        {
          sender_id: profile.email,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setPartners(response.data);
        setSelectedPartner(response.data[selected_index]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (partners.length > 0) {
      axios
        .get(process.env.REACT_APP_API_DOMAIN + "/get_prompts")
        .then((response) => {
          const selected_id = selectedPartner.partner_id;
          const filtered_prompts = response.data.filter(
            (val) => val.partner_id == selected_id
          );

          var maxValue = 0;
          for (const obj of filtered_prompts) {
            if (obj["version"] > maxValue) {
              maxValue = obj["version"];
            }
          }

          const result = [];
          for (const obj of filtered_prompts) {
            if (obj["version"] === maxValue) {
              result.push(obj);
            }
          }
          //   result.sort((a, b) => a.prompt_type.localeCompare(b.prompt_type));

          setPrompts(result);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log("FAILS");
    }
  }, [selectedPartner]);
  return (
    <div className="formMain">
      <Modal show={showConfirmation} onHide={handleCloseDataModel} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Revert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPartner != undefined ? (
            <div>
              Are you sure you want to revert to the previous version for{" "}
              {selectedPartner.partner_name}
            </div>
          ) : (
            <div></div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDataModel}>
            Close
          </Button>{" "}
          <Button variant="danger" onClick={confirmedRevert}>
            Revert
          </Button>{" "}
        </Modal.Footer>
      </Modal>

      <Button onClick={onClickBackToCopilot} variant="link" size="sm">
        {"<"} Back to Copilot
      </Button>
      {partners.length > 0 && selectedPartner !== undefined ? (
        <h2>
          Edit Prompt Config For <b>{selectedPartner.partner_name}</b>{" "}
          <img className="editPromptIcon" src={selectedPartner.icon} alt="" />
        </h2>
      ) : (
        <h1>Edit Prompt Config </h1>
      )}
      <div>
        <Dropdown>
          <Dropdown.Toggle variant="secondary" id="dropdown-basic" size="sm">
            Change Partner
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {partners.map((partner, index) => (
              <Dropdown.Item key={index} href={"?selected_index=" + index}>
                {partner.partner_name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <p>&nbsp;</p>
      <Form onSubmit={onSubmit}>
        {prompts.map((prompt, index) => (
          <div key={index}>
            <Form.Label name={prompt.prompt_type}>
              {prompt.prompt_type} Agent- Version {prompt.version}
            </Form.Label>
            <input
              type="hidden"
              id="version"
              name="version"
              value={prompt.version}
            />
            <Form.Control
              onChange={handleTextChange}
              name={prompt.prompt_type}
              as="textarea"
              rows={10}
              defaultValue={prompt.prompt_value}
            ></Form.Control>
            <p>&nbsp;</p>
          </div>
        ))}
        {isPending ? (
          <div className="savingPromps">Saving Prompts......</div>
        ) : (
          <div>
            {" "}
            <Stack direction="vertical" gap={100}>
              <Button variant="primary" type="submit">
                Submit
              </Button>
              <p>&nbsp;</p>
              <Button variant="danger" onClick={onRevertPrompts}>
                Revert
              </Button>
            </Stack>
          </div>
        )}
      </Form>
      <p>&nbsp;</p>
    </div>
  );
};

export default EditPrompts;
